import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import UserAttributesEnum from "./UserAttributesEnum";
import * as messageConstants from '../../../shared/messages';
import ClaimsCell from "./ClaimsCell";
import "./Claims.scss";
import * as samlConstants from "../../../constants/samlConstants";

class ClaimsRow extends Component {

    static propTypes = {
        id: PropTypes.number,
        displayFlexibleAttributes: PropTypes.bool,
        displayUserExtendedAttributes: PropTypes.bool,
        displayNonLdapEpicUsername: PropTypes.bool,
        extendedAttributes: PropTypes.object,
        oidcCustomClaim: PropTypes.object,
        deleteClaimFromScope: PropTypes.func,
        updateClaimInScope: PropTypes.func,
    }

    handleUpdateClaimName = (e) => {
        let claim = {
            ...this.props.oidcCustomClaim,
            "oidcCustomClaimName": e.target.value
        }
        this.props.updateClaimInScope(this.props.id, claim);
    }
    handleIdpUserAttributeEnum = (e) => {
        let claim = {
            ...this.props.oidcCustomClaim,
            "idpUserAttributeEnum": e.target.value,
            "oidcCustomClaimValue": ""
        }
        this.props.updateClaimInScope(this.props.id, claim);
    }
    handleUpdateClaimValue = (e) => {
        let claim = {
            ...this.props.oidcCustomClaim,
            "oidcCustomClaimValue": e.target.value
        }
        this.props.updateClaimInScope(this.props.id, claim);
    }
    handleUpdateAddClaimToIdToken= (e) => {
        let claim = {
            ...this.props.oidcCustomClaim,
            "addClaimToIdToken": e.target.checked
        }
        this.props.updateClaimInScope(this.props.id, claim);
    }
    handleUpdateAddClaimToAccessToken = (e) => {
        let claim = {
            ...this.props.oidcCustomClaim,
            "addClaimToAccessToken": e.target.checked
        }
        this.props.updateClaimInScope(this.props.id, claim);
    }
    handleDeleteClaimFromScope = () => {
        this.props.deleteClaimFromScope(this.props.id, this.props.oidcCustomClaim);
    }

    render() {
        return (
            <tr>
                <td className="pb-12">
                    <ClaimsCell
                        className="claim-name-input form-control attributes-input"
                        onClaimUpdate={this.handleUpdateClaimName}
                        cellData={{
                            type: "oidcCustomClaimName",
                            value: this.props.oidcCustomClaim.oidcCustomClaimName,
                            id: this.props.id,
                            placeholder: messageConstants.CLAIM_NAME
                        }}/>
                </td>
                <td className="pl-12 pb-12">
                    <UserAttributesEnum
                        onClaimUpdate={this.handleIdpUserAttributeEnum}
                        displayFlexibleAttributes={this.props.displayFlexibleAttributes}
                        displayUserExtendedAttributes={this.props.displayUserExtendedAttributes}
                        displayNonLdapEpicUsername={this.props.displayNonLdapEpicUsername}
                        extendedAttributes={this.props.extendedAttributes}
                        cellData={{
                            type: "idpUserAttributeEnum",
                            value: this.props.oidcCustomClaim.idpUserAttributeEnum,
                            id: this.props.id
                        }}/>
                </td>
                <td className="pl-12 pb-12 pr-12">
                    {this.props.oidcCustomClaim.idpUserAttributeEnum.toString() === samlConstants.CUSTOM_ATTRIBUTE
                        ? <ClaimsCell
                            className="claim-custom-value-input form-control attributes-input"
                            onClaimUpdate={this.handleUpdateClaimValue}
                            cellData={{
                                type: "oidcCustomClaimValue",
                                value: this.props.oidcCustomClaim.oidcCustomClaimValue,
                                id: this.props.id,
                                placeholder: messageConstants.VALUE
                            }}/>
                        : <div className="claim-custom-value-input"/>}
                </td>
                <td>
                    <input type="checkbox"
                           className="claim-checkbox"
                           id={"addClaimToIdToken" + this.props.id}
                           name="addClaimToIdToken"
                           value={this.props.oidcCustomClaim.addClaimToIdToken}
                           checked={this.props.oidcCustomClaim.addClaimToIdToken}
                           onChange={this.handleUpdateAddClaimToIdToken}/>
                </td>
                <td>
                    <input type="checkbox"
                           className="claim-checkbox"
                           id={"addClaimToAccessToken" + this.props.id}
                           name="addClaimToAccessToken"
                           value={this.props.oidcCustomClaim.addClaimToAccessToken}
                           checked={this.props.oidcCustomClaim.addClaimToAccessToken}
                           onChange={this.handleUpdateAddClaimToAccessToken}/>
                </td>
                <td>
                    <div className="remove-attribute-col">
                        <button type="button" onClick={this.handleDeleteClaimFromScope}
                                className="attr-button dell-button">
                            <span className="fa fa-minus btn-circle btn-minus"/>
                            <span
                                className="attr-button-label">{messageConstants.BUTTON_REMOVE_CLAIM}
                            </span>
                        </button>
                    </div>
                </td>
            </tr>
        );
    }
}

export default ClaimsRow;
